webpackJsonp([268618151857146],{

/***/ 1743:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"Dashboard","kind":"OBJECT","type":"OBJECT","fields":[{"args":[{"defaultValue":null,"description":null,"name":"additionalProviderOnly","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"limit","type":{"kind":"SCALAR","name":"Int","ofType":null}},{"defaultValue":null,"description":null,"name":"locationId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"offset","type":{"kind":"SCALAR","name":"Int","ofType":null}},{"defaultValue":null,"description":null,"name":"viewerOnly","type":{"kind":"SCALAR","name":"Boolean","ofType":null}}],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"encounters","type":{"kind":"LIST","name":null,"ofType":{"kind":"OBJECT","name":"Encounter","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-dashboard-0bba99c93af73db1d60d.js